import type { ApiFeatures } from '@exodus/asset-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import mainNetworkAssetsSelector from '@/ui/flux/assets/selectors/main-network-assets';

interface UseChainsOptions {
  withFeatures?: readonly (keyof ApiFeatures)[];
}

function useChains({ withFeatures }: UseChainsOptions = {}) {
  const assets = useSelector<unknown, Asset[]>(mainNetworkAssetsSelector);

  return useMemo(
    () =>
      assets
        .filter((asset) => {
          if (!withFeatures) {
            return true;
          }

          return withFeatures.every((feature) => asset.api.hasFeature(feature));
        })
        .map((asset) => asset.baseAssetName),
    [assets, withFeatures],
  );
}

export default useChains;
